import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconFavorite.tsx
const OutlinedFilledFavorite = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m479-87-58-52Q312-239 241.5-311.5T129-441.5q-42-57.5-58.5-105T54-643q0-101 67.5-169T289-880q56 0 104 24t86 71q44-50 90-72.5T669-880q101 0 169 68t68 169q0 49-16.5 96T831-442.5Q789-385 718-312T538-139l-59 52Z" })
});
const OutlinedFavorite = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m479-87-58-52Q312.23-239.12 241.62-311.56 171-384 129-441.5t-58.5-105Q54-594 54-643.1q0-101.22 67.66-169.06T289-880q56.29 0 104.14 24Q441-832 479-785q44-50 90.03-72.5Q615.07-880 669-880q101.38 0 169.19 67.87T906-643q0 48.97-16.5 95.99Q873-500 831-442.5 789-385 718.02-311.95 647.03-238.9 538-139l-59 52Zm-.5-124q100.74-93 165.12-158Q708-434 745.5-482.5t52-86.28q14.5-37.79 14.5-74.05 0-62.17-39.86-102.67T669.71-786q-49.01 0-91.36 32T509-666h-60q-25.75-56-68.93-88-43.18-32-91.13-32-61.21 0-100.58 39.86Q149-706.29 149-642.68q0 37.77 14.94 76.34t52.5 87.46Q254-430 317.5-365.5t161 154.5Zm2.5-288Z" })
});
const RoundedFilledFavorite = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479-118q-18 0-34.5-6T415-143l-54-51Q238-306 146.5-413.5T55-643q0-101 67-169t167-68q50 0 99 21.5t91 73.5q47-52 93-73.5t97-21.5q101 0 169 68t68 169q0 122-93 229.5T598-193l-54 50q-13 13-30 19t-35 6Z" })
});
const RoundedFavorite = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.04-118q-17.74 0-34.32-5.87-16.58-5.87-29.99-19.38L361-194Q238-306 146.5-413.5T55-643q0-101.26 66.92-169.13Q188.85-880 289-880q50 0 99 21.5t91 73.5q47-52 93-73.5t97-21.5q101.38 0 169.19 67.87T906-643q0 122-93 229.5T598-193l-54 50q-13.25 13.38-30.09 19.19-16.84 5.81-34.87 5.81ZM448-679q-23-45-68-76t-90.73-31q-61.83 0-101.05 39.86Q149-706.29 149-642.57q0 56.02 37.59 117.93 37.58 61.92 89.9 120.12 52.32 58.21 109.11 108.94 56.78 50.73 93.59 84.58 37.19-34 93.7-85.14 56.51-51.13 109.31-109.5Q735-464 773.5-525.46 812-586.92 812-643.21 812-706 771.64-746q-40.36-40-102.15-40-47.49 0-91.99 30.5Q533-725 509-679q-5.3 10-13.65 14.5Q487-660 477.5-660q-9.5 0-17.11-4.5Q452.78-669 448-679Zm32 180Z" })
});
const SharpFilledFavorite = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m479-87-58-52Q312-239 241.5-311.5T129-441.5q-42-57.5-58.5-105T54-643q0-101 67.5-169T289-880q56 0 104 24t86 71q44-50 90-72.5T669-880q101 0 169 68t68 169q0 49-16.5 96T831-442.5Q789-385 718-312T538-139l-59 52Z" })
});
const SharpFavorite = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m479-87-58-52Q312.23-239.12 241.62-311.56 171-384 129-441.5t-58.5-105Q54-594 54-643.1q0-101.22 67.66-169.06T289-880q56.29 0 104.14 24Q441-832 479-785q44-50 90.03-72.5Q615.07-880 669-880q101.38 0 169.19 67.87T906-643q0 48.97-16.5 95.99Q873-500 831-442.5 789-385 718.02-311.95 647.03-238.9 538-139l-59 52Zm-.5-124q100.74-93 165.12-158Q708-434 745.5-482.5t52-86.28q14.5-37.79 14.5-74.05 0-62.17-39.86-102.67T669.71-786q-49.01 0-91.36 32T509-666h-60q-25.75-56-68.93-88-43.18-32-91.13-32-61.21 0-100.58 39.86Q149-706.29 149-642.68q0 37.77 14.94 76.34t52.5 87.46Q254-430 317.5-365.5t161 154.5Zm2.5-288Z" })
});
const componentMap = {
	outlined: OutlinedFavorite,
	"outlined-fill": OutlinedFilledFavorite,
	rounded: RoundedFavorite,
	"rounded-fill": RoundedFilledFavorite,
	sharp: SharpFavorite,
	"sharp-fill": SharpFilledFavorite
};
const IconFavorite = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t("icon.favorite"),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconFavorite };